class SmartProgressBar extends HTMLElement {
  constructor() {
    super();
    this.tiers = [
      { goal: 2, rewardLabel: 'Spedizione Gratuita', icon: 'truck', savings: 'Spedizione Gratuita' },
      { goal: 3, rewardLabel: '<span class="spb-highlight-swing">30€</span> di sconto', icon: 'money', savings: 'Spedizione Gratuita + 30€' },
      { goal: 5, rewardLabel: '<span class="spb-highlight-swing">50€</span> di sconto', icon: 'money', savings: 'Spedizione Gratuita + 80€' },
      { goal: 7, rewardLabel: '<span class="spb-highlight-swing">70€</span> di sconto', icon: 'money', savings: 'Spedizione Gratuita + 150€' },
      { goal: 10, rewardLabel: '<span class="spb-highlight-swing">90€</span> di sconto', icon: 'gift', savings: 'Spedizione Gratuita + 240€' }
    ];
  }

  connectedCallback() {
    this.elements = {
      wrapper: this.querySelector('.smart-progress-wrapper'),
      message: this.querySelector('.spb-message'),
      fill: this.querySelector('.spb-fill'),
      iconStart: this.querySelector('.spb-icon-start'),
      iconEnd: this.querySelector('.spb-icon-end'),
      savings: this.querySelector('.spb-savings-amount')
    };

    if (!this.elements.wrapper || !this.elements.fill) return;

    // Position Pivot: Move this entire custom element inside the sticky header on all devices
    // so that it becomes part of the natural header flow and doesn't scroll-overlap it on Desktop or Mobile
    if (this.elements.wrapper.classList.contains('smart-progress-wrapper--sticky')) {
      const headerGroup = document.querySelector('sticky-header') || document.querySelector('#shopify-section-header') || document.body;
      if (headerGroup && headerGroup.firstChild !== this) {
        headerGroup.prepend(this);
        // Prepending re-triggers connectedCallback, so we exit this current execution context safely
        return; 
      }
    }

    this.lastCount = parseInt(this.elements.wrapper.dataset.count) || 0;
    
    if (window.subscribe && !this.subscribed) {
      this.subscribed = true;
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData) {
          if (event.cartData.item_count !== undefined) {
            this.updateProgress(event.cartData.item_count);
          } else if (event.cartData.sections && event.cartData.sections['cart-drawer']) {
            const drawerHtml = new DOMParser().parseFromString(event.cartData.sections['cart-drawer'], 'text/html');
            const wrapper = drawerHtml.querySelector('.smart-progress-wrapper');
            if (wrapper) {
              const count = parseInt(wrapper.getAttribute('data-count') || '0', 10);
              this.updateProgress(count);
            }
          }
        }
      });
    }

    this.updateProgress(this.lastCount, true);
  }

  getIcon(type, fallbackText) {
    if (type === 'truck') {
      return `<span style="font-size: 1.6rem; font-weight: bold;">🚚</span>`;
    } else if (type === 'money' || type === 'gift') {
      return `<strong style="font-size: 1.4rem;">${fallbackText || ''}</strong>`;
    }
    // No icon for completely empty state (start of level 1)
    return '';
  }

  getTierData(count) {
    let currentTierIndex = -1;
    let nextTier = null;
    let prevGoal = 0;
    
    // Default config values
    let prevIconType = 'none';
    let prevFallback = '';

    for (let i = 0; i < this.tiers.length; i++) {
      if (count < this.tiers[i].goal) {
        nextTier = this.tiers[i];
        if (i > 0) {
          prevIconType = this.tiers[i-1].icon;
          // Clean the prefix "Spedizione Gratuita + " out of savings to only show "-30€", "-50€"
          prevFallback = this.tiers[i-1].savings.replace('Spedizione Gratuita + ', '-');
        }
        break;
      }
      currentTierIndex = i;
      prevGoal = this.tiers[i].goal;
    }

    if (!nextTier) {
      // Per ogni prodotto extra oltre i 10, si aggiungono 24€ di sconto.
      // Il valore base dei 10 prodotti è 240€.
      const extraItems = count - 10;
      
      // Sconto TOTALE ATTUALE dello step (quello raggiunto)
      const currentTotalSavings = 240 + (extraItems * 24);
      
      // Sconto TOTALE FUTURO del prossimo step (quello bersaglio)
      const nextTotalSavings = currentTotalSavings + 24;
      
      const itemsNeeded = 1;

      return {
        level: 'max',
        itemsNeeded: itemsNeeded,
        rewardText: `<span class="spb-highlight-swing">24€</span> di sconto`,
        savingsText: `Spedizione Gratuita + ${currentTotalSavings}€`,
        percent: 8, // Always leave visual momentum for level 10+
        iconStartHtml: this.getIcon('money', `-${currentTotalSavings}€`), 
        iconEndHtml: this.getIcon('money', `-${nextTotalSavings}€`) 
      };
    }

    const itemsNeeded = nextTier.goal - count;
    const itemsInCurrentStep = nextTier.goal - prevGoal;
    const itemsCompletedInStep = count - prevGoal;
    
    let percent = (itemsCompletedInStep / itemsInCurrentStep) * 100;
    if (percent === 0 && count > 0) percent = 8; 
    percent = Math.max(0, Math.min(100, percent));

    let savingsText = '0€';
    if (currentTierIndex >= 0) {
      savingsText = this.tiers[currentTierIndex].savings;
    }
    
    // Clean target fallback for the next icon directly
    const nextFallback = nextTier.savings.replace('Spedizione Gratuita + ', '-');

    return {
      level: currentTierIndex + 1,
      itemsNeeded,
      rewardText: nextTier.rewardLabel,
      savingsText,
      percent,
      iconStartHtml: this.getIcon(prevIconType, prevFallback),
      iconEndHtml: this.getIcon(nextTier.icon, nextFallback)
    };
  }

  updateProgress(count, isInitial = false) {
    if (this.elements.wrapper.dataset.count === count.toString() && !isInitial) return;
    
    this.elements.wrapper.dataset.count = count;
    const alwaysShow = this.elements.wrapper.dataset.alwaysShow === 'true';

    if (count === 0 && !alwaysShow) {
      if (this.elements.wrapper) {
        this.elements.wrapper.style.opacity = '0';
        
        setTimeout(() => { 
          if(this.elements.wrapper.dataset.count === '0') {
            this.classList.add('spb-is-hidden');
            this.elements.wrapper.style.display = 'none'; 
          }
        }, 300);
      }
      return;
    } else {
      if (this.elements.wrapper) {
        this.classList.remove('spb-is-hidden');
        
        // If it was previously hidden, reset width to 0 visually first
        if (this.elements.wrapper.style.display === 'none' || this.elements.fill.style.width === '') {
           this.elements.fill.style.removeProperty('transition');
           this.elements.fill.removeAttribute('style');
           this.elements.fill.setAttribute('style', `width: 0% !important; transition: none !important;`);
        }
        
        this.elements.wrapper.style.display = '';
        
        void this.elements.wrapper.offsetWidth;
        
        this.elements.wrapper.style.opacity = '1';
      }
    }

    const data = this.getTierData(count);
    const prevTierData = this.lastCount > 0 ? this.getTierData(this.lastCount) : null;
    let isGoalHit = !isInitial && prevTierData && prevTierData.level !== data.level && count > this.lastCount;
    if (!isInitial && count > 10 && count > this.lastCount) {
        isGoalHit = true; 
    }

    this.lastCount = count;

    if (count === 0 && alwaysShow) {
      this.elements.message.innerHTML = `Inizia il tuo shopping per sbloccare fantastici premi!`;
    } else {
      this.elements.message.innerHTML = `Aggiungi <strong>${data.itemsNeeded}</strong> ${data.itemsNeeded === 1 ? 'prodotto' : 'prodotti'} per sbloccare <strong>${data.rewardText}</strong>!`;
    }

    const isDrawer = this.elements.wrapper.classList.contains('smart-progress-wrapper--drawer');
    const delay = (isDrawer && !isInitial) || (count === 1 && !alwaysShow && !isInitial) ? 400 : 0;
    
    const iconStart = this.elements.iconStart;
    const iconEnd = this.elements.iconEnd;

    setTimeout(() => {
      // Clean up any lingering transition overrides safely
      this.elements.fill.removeAttribute('style');
      this.elements.fill.classList.remove('spb-fill--slowing');

      if (isGoalHit) {
        this.elements.fill.setAttribute('style', `width: 100% !important;`);
        this.elements.fill.innerHTML = `&nbsp;`; // Force layout
        this.elements.fill.dataset.level = prevTierData ? prevTierData.level : data.level;
        
        if (iconEnd && iconEnd.innerHTML.trim() !== '') {
          iconEnd.classList.remove('spb-animate-pop');
          void iconEnd.offsetWidth;
          iconEnd.classList.add('spb-animate-pop');
        }
        this.elements.wrapper.classList.add('spb-animate-glow');
        
        setTimeout(() => {
          this.elements.wrapper.classList.remove('spb-animate-glow');
          this.elements.fill.dataset.level = data.level;
          
          // Apply slowing class specifically for the backward stretch
          this.elements.fill.classList.add('spb-fill--slowing');
          this.elements.fill.setAttribute('style', `width: ${data.percent}% !important;`);
          
          if (iconStart && iconStart.innerHTML !== data.iconStartHtml) iconStart.innerHTML = data.iconStartHtml;
          if (iconEnd && iconEnd.innerHTML !== data.iconEndHtml) iconEnd.innerHTML = data.iconEndHtml;
        }, 800);
      } else {
        this.elements.fill.setAttribute('style', `width: ${data.percent}% !important;`);
        this.elements.fill.innerHTML = `&nbsp;`; // Force layout
        this.elements.fill.dataset.level = data.level;
        
        if (iconStart && iconStart.innerHTML !== data.iconStartHtml) iconStart.innerHTML = data.iconStartHtml;
        if (iconEnd && iconEnd.innerHTML !== data.iconEndHtml) iconEnd.innerHTML = data.iconEndHtml;
      }
    }, delay);

    this.elements.savings.innerHTML = Object.is(data.savingsText, '0€') ? '0€' : data.savingsText;
  }
}

customElements.define('smart-progress-bar', SmartProgressBar);
